import { html  } from 'lit';
import IVPLitElementBase from './lit-element-base.js';
import Api from './api.js'
import DlgProgress from './progress-dialog.js';
import axios from 'axios';
import DlgPopup from './popup-dialog.js';
import ico_p7m from '../icons/p7m.svg'

export default class DlgContractorDocument extends IVPLitElementBase {

	static get tag() { return "contractor-document-dialog" }

    static get properties() {
        return {            
            /*title:  { type: String },*/
        };
    }

    constructor() {
        super();

        this.dialog_id = "contractor_document_dialog"
        this.file = {
            
        }
    }

    render() {
        return html`
        <!-- Modal -->
        <div class="modal fade" id="${this.dialog_id}" tabindex="-1" role="dialog" style="display: none;" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento</h5>
                        <button type="button" class="close" @click="${this.OnClose}" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div  style="height: 100%; box-sizing: content-box; position: relative;">
                            <div class="form-group col-6">
                                <label for="document_name" class="">Nome del documento</label>
                                <input type="text"" 
                                    class="field form-control" id="document_name" ?disabled=${this.readonly==true} placeholder="Nome del documento" value="${this.file.name}">                                            
                            </div> 
                            <a href="javascript:void(0)" class="btn-remove ${this.file.view_url==null || this.readonly==true?'hidden':''}" @click="${this._RemoveDocument}">Ricarica documento</a>
                            <div class="col-12 document-container flex-column  d-flex justify-content-center align-items-center">                                
                                ${(this.file == null || this.file.view_url == null)?this._render_placeholder():this._render_document()}                            
                            </div>                                                               
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="${this.OnSave}">${this.readonly==true?'Chiudi':'Salva'}</button>
                    </div>
                </div>
            </div>
        </div>
        `
    }
    
    _render_document() {
        return html`${(this.file.type == "pdf")?
                html`<embed src="${this.file.view_url}" frameborder="0" width="100%" height="100%" />`:
                (this.file.type == "jpg")?
                    html`<img src="${this.file.view_url}" style="max-width:100%;"/>`:
                    html`
                        <div class="row" style="height: 100%;">
                            <div class="col"></div>
                            <div class="col-3 d-flex flex-column justify-content-center">
                                <div class="pt-3 d-flex flex-column justify-content-center" style="background-color: white; padding: 10px;">
                                    <img src="${ico_p7m}" style="height:100px;"/>
                                    <a href="${this.file.view_url}" target="_blank">Download</a>
                                </div>
                            </div>
                            <div class="col"></div>                                        
                        </div>
                        `                                    
                }`
    }

    _render_placeholder() {
        return html`
        <a href="javascript:void(0)" class="file-selector d-flex justify-content-center align-items-center link-secondary" ?disabled=${"disabled"} @click="${this._OnSelectFile}"> 
            <i class="bx bxs-cloud-upload mr-2" style="font-size:25px;"></i>
            <span>Carica un documento (Formati accettati: PDF, JPEG o P7M)</span>
        </a>        
        `
    }

    firstUpdated(changedProps) {
        $(`#${this.dialog_id}`).modal({backdrop:'static',keyboard:false})
        document.body.classList.add("overflow-hidden")
    }

    updated() {  

    }

    async _OnSelectFile(evt) {
        if (this.getAttribute("disabled") != null)
            return
        // Apre il dialogo di caricamento file
        let input_file = document.createElement("input");
        input_file.setAttribute("type", "file");
        input_file.setAttribute("accept", "image/jpeg, application/pdf, application/pkcs7-mime, .pdf, .jpg, .jpeg, .p7m");
        
        input_file.addEventListener('change', async () => {
            var file = input_file.files[0];
        
            if (file.name.toLowerCase().match(/\.(pdf|jpg|jpeg|p7m)$/)) {
                let progress_dlg = null
                try {
                    // Esegue la chiamata per ottenere il link di upload
                    let res = await Api.UploadInit(file.name)
                    console.log(res)

                    // Gestisce l'errore se il server risponde picche

                    // Mostra il dialogo di progress
                    progress_dlg = DlgProgress.Show("Caricamento file","Caricamento del file in corso, attendere il completamento.")
                    let headers = { 'Content-Type': 'application/pdf' }    
                    let type = "pdf"                
                    let name_lower_case = file.name.toLocaleLowerCase()
                    if (name_lower_case.endsWith(".jpg") || name_lower_case.endsWith(".jpeg")) {
                        headers = { 'Content-Type': 'image/jpg' }
                        type = "jpg"                
                    }
                    else if (name_lower_case.endsWith(".p7m")) {
                        headers = { 'Content-Type': 'application/pkcs7-mime' }
                        type = "p7m"                
                    }
                    

                    // Esegue l'upload andando ad aggiornare il valore del progress
                    const axiosResponse = await axios({
                        method: 'put',
                        url: res.upload_url,      
                        data: file,
                        headers: headers,
                        onUploadProgress: (progressEvent) => {
                            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                            console.log(percentCompleted)
                            progress_dlg.percent = percentCompleted
                        }                  
                    });
                
                    console.log(axiosResponse)

                    this.file.file = res.file_name
                    this.file.key = res.upload_key,
                    this.file.view_url = res.view_url,
                    this.file.type = type

                    this.querySelector(".btn-remove").classList.remove("hidden")
                    this.update()

                    setTimeout(()=>{ 
                        progress_dlg.Remove()
                        
                     },1000)
                }
                catch (Ex) {
                    console.error(Ex)
                    setTimeout(()=> {
                        if (progress_dlg != null) 
                            progress_dlg.Remove()                    
                        DlgPopup.Show("Errore","Ooops! C'è stato un errore durante l'upload del file. Riprovare.");                    
                    },1000)
                }

            } else {
                DlgPopup.Show("Tipo di file non valido","Sono supportati solo i tipi file: PDF, JPEG o P7M");
            }
        });
        
        input_file.click();

    }

    _RemoveDocument() {
        this.file.view_url = null
        this.querySelector(".btn-remove").classList.add("hidden")
        this.update()
    }

    static Show(file, readonly) {

        let el = new DlgContractorDocument()
        
        if (file != null)
            el.file = file

        el.readonly = readonly
        el.promise = new Promise((resolve) => {
            el.promise_resolve = resolve
        })
        
        let vels = document.querySelectorAll(this.tag)
		if (vels != null)
			vels.forEach((el)=>{ el.remove() })

        document.body.append(el)
        return el.promise
    }

    Remove() {
        $('#contractor_document_dialog').modal('hide')
        document.body.style.overflow = null
        document.body.classList.remove("overflow-hidden")
        this.remove()
    }    

    async OnSave() {
        if (this.readonly!=true) {

            let name = String(this.querySelector("#document_name").value).trim()

            if (name == "") {
                await DlgPopup.Show("Valore mancante","Il nome del documento non puù essere vuoto")
                return 
            }

            this.file.name = name
            
            this.promise_resolve(this.file)
        }
        else 
            this.promise_resolve(null)
        this.Remove()
    }

    OnClose() {
        this.promise_resolve(null)
        this.Remove()
    }
    
}
DlgContractorDocument.RegisterElement()